import {BASE_DATA_URL} from '../../envs.ts';

import VectorSource from 'ol/source/Vector.js';
import VectorLayer from 'ol/layer/Vector.js';

import {ol as flatgeobuf} from 'flatgeobuf';

import type {Options as VectorLayerOptions} from 'ol/layer/Vector';

const crosscountrySource = new VectorSource({
  loader: async () => {
    const response = await fetch(
      `${BASE_DATA_URL}/crosscountry_import/crosscountry.2056.simple_5.fgb`,
    );
    const features = [];
    for await (const feature of flatgeobuf.deserialize(response.body)) {
      features.push(feature);
    }
    crosscountrySource.addFeatures(features);
  },
});

const style = [
  {
    filter: ['<=', ['resolution'], 10],
    style: {
      'stroke-color': '#078065',
      'stroke-width': 4.5,
    },
  },
  {
    else: true,
    filter: ['<=', ['resolution'], 50],
    style: {
      'stroke-color': '#078065',
      'stroke-width': 3.5,
    },
  },
];

export class CrosscountryNetworkLayer extends VectorLayer<VectorSource> {
  constructor(options?: VectorLayerOptions) {
    super(
      Object.assign(
        {
          style: style,
          source: crosscountrySource,
        },
        options,
      ),
    );
  }
}
